import { useEffect, useState } from "react";

import { Copy } from "iconsax-react";
import LinkWithPopover from "../common/LinkWithPopover";
import { CircularProgress, Stack } from "@mui/material";
import errorResolver from "../../../utils/error-resolver";
import MuiTextField from "../../common/text-field/MuiTextField";
import { useProtectedAxiosInstance } from "../../../hooks/axiosInstance";
import { useNotificationContext } from "../../../context/notificationContext";
import { AccessTokensListRequest } from "../../../services/Endpoints/access-tokens/AccessTokensEndpoint";
interface IPropsShowAccessToken {
  tokenId: number;
}

export default function ShowCardAccessToken({
  tokenId,
}: IPropsShowAccessToken) {
  const [isCopy, setIsCopy] = useState<boolean>(false);
  const [waiting, setWaiting] = useState(false);
  const [accessToken, setAccessToken] = useState({
    secret: "",
  });
  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();
  const getData = async () => {
    try {
      setWaiting(true);
      const showToken = new AccessTokensListRequest(protectedInstance);
      const resp = await showToken.showToken(JSON.stringify(tokenId));
      setAccessToken({
        secret: resp.data?.secret || "",
      });
      setWaiting(false);
    } catch (error) {
      errorResolver({ error, setNotification });
      setWaiting(false);
      console.error(error);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  if (waiting) {
    return (
      <Stack
        width={"100%"}
        height={"125px"}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"center"}
        display={'flex'}
        p={'10px'}
        overflow={'hidden'}
      >
        <CircularProgress size={'100px'} />
      </Stack>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Stack position="relative">
        <MuiTextField
          multiline
          label="توکن دسترسی secret"
          value={accessToken.secret}
        />
        <Stack
          left="10px"
          bottom="10px"
          position="absolute"
          sx={{ cursor: "pointer" }}
          onClick={() => {
            navigator.clipboard.writeText(accessToken.secret);
            setIsCopy(true);
          }}
        >
          <LinkWithPopover title={isCopy ? "کپی شد" : "کپی کردن"}>
            <Copy />
          </LinkWithPopover>
        </Stack>
      </Stack>
    </div>
  );
}
